import React, { useState } from "react";
import { Switch } from "react-router-dom";
import "./Menu.css";
import PrivateRoute from "../PrivateRoute/PrivateRoute";
import Dashboard from "../../views/Dashboard/Dashboard";
import Login from "../../views/Auth/Login/Login";
import Signup from "../../views/Auth/Signup/Signup";
import { Route } from "react-router-dom";
import MenuTopBar from "./MenuTopBar";

export default function MainMenu(props) {
  const [activeCards, setActiveCards] = useState({
    fmRadio: false,
    tickets: false,
    schwab: false,
    dice: false,
    videos: false,
    gipirt: false,
    finance: false,
    beeminder: false,
    random: false,
    food: false,
    throw: false,
    laugh: false,
  });

  return (
    <div       
      id="dashboard"
      style={{
        backgroundColor: "whitesmoke",
        width: "100vw",
        height: "100vh",
        position: "relative",
      }}
    >
      <MenuTopBar activeCards={activeCards} setActiveCards={setActiveCards} />
      <Switch>
        <Route path={"/login"} component={Login} />
        <Route path={"/signup"} component={Signup} />
        <PrivateRoute 
          path={"/"} 
          render={() => <Dashboard activeCards={activeCards} setActiveCards={setActiveCards} />}
        />
      </Switch>
    </div>
  );
}
